// the readout sits just right of and above the pointer and stays inside the chart box
const EDGE        : number = 4;
const OFFSET_X    : number = 14;
const OFFSET_Y    : number = 10;
const PANEL_WIDTH : number = 170;

export function infoPanelPosition ( event : MouseEvent, bounds : DOMRect ) : { x : number; y : number; } {
  return {
    x: Math.min(event.clientX - bounds.left + OFFSET_X, bounds.width - PANEL_WIDTH),
    y: Math.max(event.clientY - bounds.top - OFFSET_Y, EDGE)
  };
}
